import React from 'react';

/** Lazy ClientComputedBreadcrumb (not wrapped in a suspense to use the parent widget loading fallback) */
export const ClientComputedBreadcrumb = React.lazy(
    () =>
        import(
            /* webpackChunkName: 'widget-breadcrumb' */
            './ClientComputedBreadcrumb'
        ),
);
